export default __webpack_public_path__ + "static/media/verify.6023685b.svg";